<div class="layout-sidebar" [ngClass]="{'layout-sidebar-active': appMain?.sidebarActive}" (click)="appMain?.onSidebarClick($event)"
     (mouseover)="appMain && (appMain.sidebarActive=true)" (mouseleave)="appMain && (appMain.sidebarActive=false)">
    <div class="sidebar-logo">
        <a href="#" class="sidebar-pin" title="Toggle Menú" (click)="appMain?.onToggleMenuClick($event)">
            <i class="pi pi-lock" *ngIf="appMain?.staticMenuActive"></i>
            <i class="pi pi-lock-open" *ngIf="!appMain?.staticMenuActive"></i>
        </a>
        <a routerLink="/">
            <img alt="logo" [src]="urlImageLogo" />
            <span class="app-name">{{marca}}</span>
        </a>
    </div>


    <div class="layout-menu-container" (click)="onMenuClick()">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    </div>
    <div class="layout-sidebar-apps" *ngIf="appDownloadLinks.length">
        <div class="layout-sidebar-apps__title">Descarga la app</div>
        <ul class="layout-menu">
            <li *ngFor="let app of appDownloadLinks">
                <a [href]="app.url" target="_blank" rel="noopener noreferrer"
                   [attr.aria-label]="app.ariaLabel">
                    <span class="menuitem-text">{{app.platform}} <span class="store">· {{app.store}}</span></span>
                    <i class="pi" [ngClass]="app.icon" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </div>
</div>
